// 站点级共享配置
// 企业微信客服咨询入口：所有「立即咨询」按钮统一跳转此地址
export const WECHAT_WORK_CONSULT_URL = 'https://work.weixin.qq.com/kfid/kfc74581ebac764f7e5'
